import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import LanguageConsumer from './context/lang';

ReactDOM.render(
  <React.StrictMode>
    <LanguageConsumer>
      <App />
    </LanguageConsumer>
  </React.StrictMode>,
  document.getElementById('root')
);
